
import request from '@/utils/request'

export default {
  /****文件上传  Api */
  //文件上传，附件格式fileType：1-图片，2-录音 3-短信
  agentManagePage:(data,fileData)=>{
    return request({
      url: `/minio/upload?type=${data.type}&fileType=${data.fileType}&name=${data.name}&orderId=${data.orderId}`,
      method: 'post',
      data:fileData
    })
  },
  //获取附件列表
  minioGetList:(data)=>{
    return request({
      url: `/minio/getList`,
      method: 'post',
      data:data
    })
  },
  //通过手机验证码修改密码
  merchantUpdatePasswordNew:(data)=>{
    return request({
      url: `/merchant/admin/updatePasswordNew`,
      method: 'post',
      data:data
    })
  },
  //获取验证码 type-短信类型 1-绑定手机 2-注册/登录 3-修改密码
  merchantGetAuthCode:(data)=>{
    return request({
      url: `/merchant/admin/getAuthCode`,
      method: 'get',
      params:data
    })
  },
  
  //查询律助列表
  listOper:(data)=>{
    return request({
      url: `/order/listOper`,
      method: 'post',
      data:data
    })
  },

  //查询协商老师列表
  listTeacher:(data)=>{
    return request({
      url: `/order/listTeacher`,
      method: 'post',
      data:data
    })
  },
  //查询协商老师列表
  listAgent:(data)=>{
    return request({
      url: `/order/listAgent`,
      method: 'post',
      data:data
    })
  },
  //查询待关联合同的支付记录
  getPayList:(data)=>{
    return request({
      url: `/order/getPayList`,
      method: 'GET',
      params:data
    })
  },
  
  //修改指定客户密码
  updatePassword:(data)=>{
    return request({
      url: `/admin/updatePassword`,
      method: 'post',
      data:data
    })
  },

  
  //获取 type : 1 前端市场专员/ 2 : 律助   列表
  getAdminByType:(data)=>{
    return request({
      url: `/order/getAdminByType`,
      method: 'get',
      params:data
    })
  },
//获取 type : 1 前端市场专员/ 2 : 律助   列表   场景=》退费管理  =》手动添加退费
getAdminByTypeRefund:(data)=>{
  return request({
    url: `/order/getAdminByTypeRefund`,
    method: 'get',
    params:data
  })
},



  //获取 指定公司客户
  getMemberList:()=>{
    return request({
      url: `/order/getMemberList`,
      method: 'GET',
      params:{}
    })
  },

  

  
  //获取 指定公司操作员  默认律所
  getNegLawyer:()=>{
    return request({
      url: `/order/getNegLawyer`,
      method: 'GET',
      params:{}
    })
  },
  
  //解卡  指派律师
  updateNegLawyer:(data)=>{
    return request({
      url: `/order/updateNegLawyer`,
      method: 'GET',
      params:data
    })
  },
  
  //解卡  取消申请指派律师
  noApplyLawyer:(data)=>{
    return request({
      url: `/order/noApplyLawyer`,
      method: 'GET',
      params:data
    })
  },
  
  //获取客服人员只显示is_phone=1的操作员  是否是电话客服 0-否，1-是
  getPhoneOperator:(data)=>{
    return request({
      url: `/order/getPhoneOperator?isPhone=${data.isPhone}`,
      method: 'POST',
      data:{}
    })
  },
  //市场专员发起欣业邦的银行卡转账
  transPayApply:(data)=>{
    return request({
      url: `/order/transPayApply`,
      method: 'POST',
      data:data
    })
  },
  
  //获取员工的考勤公司id
  getOperCompany:(data)=>{
    return request({
      url: `/admin/getOperCompany`,
      method: 'get',
      params:data
    })
  },
  //获取考勤公司id列表
  getOperCompanyList:(data)=>{
    return request({
      url: `/admin/getOperCompanyList`,
      method: 'get',
      params:data
    })
  },
}



// WEBPACK FOOTER //
// ./src/api/baseApi.js